var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAc = function SvgAc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 19.1667H4.99984C3.1665 19.1667 1.6665 17.6667 1.6665 15.8333V8.33333C1.6665 6.5 3.1665 5 4.99984 5H34.9998C36.8332 5 38.3332 6.5 38.3332 8.33333V15.8333C38.3332 17.6667 36.8332 19.1667 34.9998 19.1667Z",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6998 25.2998C10.6998 27.8165 10.4498 30.9665 8.6665 32.9998C8.6665 32.9998 7.59984 34.5165 5.34984 34.5165C5.33317 34.5165 5.33317 34.5165 5.3165 34.5165C3.29984 34.5165 1.6665 32.8831 1.6665 30.8665",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2998 25.2998C29.2998 27.8165 29.5498 30.9665 31.3331 32.9998C31.3331 32.9998 32.3998 34.5165 34.6498 34.5165C34.6665 34.5165 34.6665 34.5165 34.6831 34.5165C36.6998 34.5165 38.3331 32.8831 38.3331 30.8665",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.2998V35.1165",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3996 13.8833H9.59961",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgAc;